// 关于我们
const about = {
  'about.tab.title': 'Tentang Kami',
  'about.welcome': 'Selamat datang di QuickFox,',
  'about.list.check': 'Periksa Pembaruan',
  'about.list.contact': 'Hubungi Kami',
  'about.list.like': 'Berikan Ulasan Bagus',
  'about.list.terms': 'Syarat Layanan',
  'about.list.policy': 'Kebijakan Privasi',
  'about.list.vip': 'Perjanjian Layanan Keanggotaan',
};

// 联系我们
const contact = {
  'contact.tab.title': 'Hubungi Kami',
  'contact.title': 'Anda dapat menghubungi kami dengan cara berikut',
  'contact.list.offcial': 'Situs Web Resmi',
  'contact.list.wx': 'Akun Resmi WeChat',
  'contact.list.qq': 'Layanan Pelanggan QQ',
  'contact.list.qqgroup': 'Grup QQ Resmi',
  'contact.list.wxkf': 'Dukungan Teknis WeChat',
  'contact.list.email': 'Email',
  'contact.list.op.visit': 'Kunjungi',
  'contact.list.op.copy': 'Salin Nomor',
  'contact.list.op.copyAccount': 'Salin Akun',
  'contact.list.op.copy.mail': 'Salin Alamat',
  'contact.copy': 'Salin Berhasil',
};
// 帮助
const help = {
  'help.tab.title': 'Bantuan',
  'help.title': 'Butuh bantuan manusia? Klik untuk menghubungi layanan pelanggan online',
  'help.contact': 'Hubungi Sekarang',
  'help.head.speedUp': 'Percepat',
  'help.head.recharge': 'Isi ulang',
  'help.head.other': 'Lainnya',
  'help.pv': 'Tayangan Halaman Bantuan',
  'help.speed': 'Percepat',
  'help.other': 'Lainnya',
  'help.vip': 'Anggota',
};

// 帮助详情
const helpDetail = {
  'helpDetail.tab.title': 'Detail',
  'helpDetail.about': 'Pertanyaan Terkait',
};
const notice = {
  'notice.tab.title': 'Pusat Pesan',
  'notice.nodata': 'Belum ada pesan~',
  'notice.numberOfMsgJumpClick': 'Tingkat klik dari tombol pesan dalam situs ke halaman anggota',
  'notice.getItRightnow': 'Klik untuk Klaim',
  'notice.allReadyGetIt': 'Sudah Diklaim',
  'notice.getItSuccessfully': 'Klaim Berhasil',
  'notice.rechargeNow': 'Isi Ulang Sekarang',
};
// 技术支持
const tsupport = {
  'tsupport.title': 'Dukungan Teknis',
  'tsupport.wechatDesc': 'Dukungan Teknis QuickFox',
  'tsupport.addService': 'Tambahkan layanan pelanggan sekarang',
  'tsupport.tip': 'Jika Anda mengalami crash, ketidakmampuan untuk mempercepat, lag, atau masalah lain yang memengaruhi penggunaan normal, silakan hubungi kami.',
  'tsupport.unSupport': 'Belum didukung',
};
// Http
const http = {
  'http.prompt.networkError': 'Kesalahan jaringan',
};
const Welfare = {
  'welfare.header.todayincome': 'Pendapatan Hari Ini',
  'welfare.header.totalincome': 'Total Pendapatan',
  'welfare.coinsTasks': 'Tugas Koin Emas',
  'welfare.tasksCard.chekout': 'Lihat',
  'welfare.tasksCard.coins': 'Koin Emas',
  'welfare.tasks.invite': 'Hadiah Undangan',
  'welfare.tasks.invite.unit': 'Koin Emas/Orang',
  'welfare.tasks.invite.desc': 'Undang untuk Dapatkan Keanggotaan Tahunan',
  'welfare.tasks.invite.descript': 'Undang Teman untuk Dapatkan Koin Emas, Jutaan Angpao Menanti',
  'welfare.tasks.sign': 'Check-in Harian',

  'welfare.tasks.sign.descript': 'Dapatkan hingga 50 koin emas setiap hari',
  'welfare.tasks.wx': 'Ikuti akun resmi',
  'welfare.tasks.bindEmail': 'Hadiah pengikatan',
  'welfare.tasks.bindText': 'Pergi mengikat',
  'welfare.tasks.bindEmail.descript': 'Ikat email atau nomor telepon untuk mengklaim koin emas',
  'welfare.tasks.bindEmail.desc': '+6 jam durasi VIP',
  'welfare.tasks.bindEmail.bindTimes': '+6 jam VIP',
  'welfare.tasks.share': 'Berbagi untuk hadiah',
  'welfare.tasks.share.descript': 'Bagikan poster di media sosial, unggah tangkapan layar untuk mendapatkan 100 koin',
  'welfare.tasks.wx.descript': 'Ikuti akun resmi QuickFox WeChat untuk mendapatkan 30 koin',
  'welfare.sign.dayno': 'Hari ke-{day}',
  'welfare.sign.vipTime': '{vipTime} {vipTimeType} VIP',
  'welfare.sign.ticket': 'Kupon 50￥',
  'welfare.sign.day': 'Hari',
  'welfare.sign.hadSign': 'Check-in Berturut-turut',
  'welfare.sign.sign': 'Check-in',
  'welfare.sign.signed': 'Sudah Check-in',
  'welfare.sign.tips': 'Dapatkan hadiah besar untuk check-in berturut-turut~',
  'welfare.sign.successText': 'Check-in Berhasil',
  'welfare.sign.rule.title': 'Aturan Check-in',
  'welfare.sign.rule.modalTitle': 'Aturan Check-in',
  'welfare.sign.rule.7day': 'Selamat karena berhasil masuk! Anda telah memperoleh durasi VIP {vipTime} {vipTimeType},',
  'welfare.sign.rule.download': 'Unduh Aplikasi QuickFox',
  'welfare.sign.rule.downloadLast': 'Anda dapat menikmati percepatannya. ',
  'welfare.sign.rule.yancaoRedpack': 'kupon diskon pengiriman 50 yuan untuk pembelian lebih dari 500 yuan, telah diterima',
  'welfare.sign.rule.eventTime': 'Waktu Acara: 2024-12-24 12:00 hingga 2025-1-2 18:00',
  'welfare.sign.rule.part1': 'Untuk setiap {signCount} {signTimeType} check-in berturut-turut, Anda bisa mendapatkan durasi VIP {rewardVipTime} {rewardTimeType};',
  'welfare.sign.rule.part2': 'Untuk setiap {signCount} {signTimeType} check-in berturut-turut, Anda bisa mendapatkan durasi VIP {rewardVipTime} {rewardTimeType};',
  'welfare.sign.rule.part3': 'Check-in yang terputus akan mengatur ulang hitungan hari;',
  'welfare.sign.rule.part4': 'Pendaftaran berganda pada perangkat yang sama tidak mencatat hadiah check-in; dilarang mendapatkan hadiah check-in dengan cara yang tidak pantas.',
  'welfare.sign.rule.interpretation': 'Milik QuickFox',
  'welfare.sign.successTips': 'Check-in berhasil, {todayReward} koin didapat. Jangan lupa datang setiap hari~',
  'welfare.sign.signSuccess': 'Sukses',
  'welfare.sign.signSuccessVip': 'Check-in berhasil, {vipTime}{timeType}VIP waktu sudah didapat, jangan lupa datang setiap hari~',
  'welfare.sign.ruleDetail': 'Check-in harian dapatkan 2 koin. Check-in berturut 7 hari dapat hadiah tambahan. Maksimal 50 koin per hari. Jangan lupa datang setiap hari!',

  'welfare.sign.ruleDetail2': 'Pendaftaran berulang pada perangkat yang sama tidak akan diberi hadiah koin. Cara tidak adil untuk mendapatkan hadiah koin dilarang. QuickFox berhak mencabut hadiah koin dan menutup pesanan penukaran.',
  'welfare.wx.follow': 'Ikuti Akun Resmi',
  'welfare.wx.welfareForInvite': 'Hadiah Undangan',
  'welfare.wx.signIn': 'Hadiah Berbagi',
  'welfare.wx.toSignIn': 'Pergi ke Check-in',
  'welfare.wx.toFollow': 'Pergi ke Ikuti',
  'welfare.wx.toInvite': 'Undang',
  'welfare.wx.toGet': 'Tersedia',
  'welfare.wx.toGetHighest': 'Hadiah Maksimum',
  'welfare.wx.qrcodeTip.saved': 'Kode QR disimpan ke album',
  'welfare.wx.qrcodeTip.failed': 'Gagal menyimpan kode QR',
  'welfare.wx.qrcodeTip.version': 'Silakan unduh versi terbaru untuk menyimpan kode QR!',
  'welfare.wx.Intro.title': 'Pengantar Tugas',
  'welfare.wx.Intro.step': 'Langkah-langkah ',
  'welfare.wx.Intro.follow': 'Ikuti',
  'welfare.wx.Intro.reward': 'Hadiah',
  'welfare.wx.Intro.rewardText1.part1': 'Dapatkan dengan Mengikuti',
  'welfare.wx.Intro.rewardText1.part2': '{vipCount} jam VIP',
  'welfare.wx.Intro.pc.scanit': 'Gunakan WeChat "Scan" untuk memindai gambar di bawah',
  'welfare.wx.Intro.mobile.scanit': 'Simpan kode QR di bawah ke album, buka WeChat, dan pilih "Scan" untuk memindainya',
  'welfare.wx.Intro.follow.descrip': 'Klik tombol "Ikuti" di pojok kanan atas untuk menyelesaikan tugas',
  'welfare.invite.rule.title': 'Aturan',
  'welfare.invite.personNum': 'diundang (orang)',
  'welfare.invite.viewDetail': 'Lihat Detail',
  'welfare.invite.inviteDetail': 'Detail Undangan',
  'welfare.invite.coinNum': 'Hadiah Undangan (Koin)',
  'welfare.invite.dayNum': 'Hadiah Undangan (Hari)',
  'welfare.invite.duration': 'Durasi Hadiah (Hari)',
  'welfare.invite.toGoods': 'Pertukaran Koin',
  'welfare.invite.rewardDetail': 'Detail Hadiah',
  'welfare.invite.face2face': 'Poster & Undangan Tatap Muka Klik',
  'welfare.invite.copyLink': 'Salin Tautan Undangan',
  'welfare.invite.post.saved': 'Poster disimpan ke album',
  'welfare.invite.post.failed': 'Gagal menyimpan poster',
  'welfare.invite.post.descrip.tips': 'Simpan poster atau tangkapan layar untuk dibagikan kepada teman, undang teman untuk memindai kode QR, dan Anda dan teman Anda masing-masing akan menerima 100 koin emas setelah undangan berhasil',
  'welfare.invite.post.version': 'Untuk menyimpan poster, Anda perlu mengunduh versi terbaru!',
  'welfare.invite.post.pcAppTip': 'Silakan pergi ke aplikasi QuickFox untuk menyimpan poster!',
  'welfare.invite.post.saveBtn': 'Simpan Poster',
  'welfare.invite.post.descrip.regist': 'Pindai Kode QR untuk MendaftarAkun QuickFox, ',
  'welfare.invite.post.descrip.speedOnce': 'Unduh AplikasiGunakan Akselerasi Sekali, ',
  'welfare.invite.post.descrip.getCoins': 'Anda dan TemanMasing - masing Mendapat 100 Koin Emas, ',
  'welfare.invite.process.regist': 'Teman KlikTautan Undangan untuk Mendaftar, ',
  'welfare.invite.process.speedOnce': 'Unduh AplikasiGunakan akselerasi sekali, ',
  'welfare.invite.process.getCoins': 'Anda dan temanmasing - masing mendapatkan 100 koin emas, ',
  'welfare.invite.process.tips': '*Teman perlu masuk ke akun yang terdaftar di tautan undangan di perangkat seluler baru (yaitu, ponsel yang belum pernah masuk ke akun QuickFox sebelumnya), dan menggunakan akselerasi sekali untuk menerima hadiah.',
  'welfare.invite.link.title': 'Anda memiliki Super VIP yang bisa diklaim',
  'welfare.invite.link.descrip': 'QuickFox Accelerator memberikan manfaat sekarang, daftar untuk mendapatkan Super VIP, dan ada amplop merah tunai menunggu Anda untuk diambil!',
  'welfare.invite.historyBtn': 'Detail Undangan',
};

const PageTitle = {
  'pageTitle.goods': 'Mall',
  'pageTitle.welfare': 'Manfaat',
  'pageTitle.invite.detail': 'Detail Undangan',
  'pageTitle.taskDetails': 'Ikuti Akun Resmi',
  'pageTitle.inviteDetails': 'Undang dan Dapatkan Hadiah',
  'pageTitle.taskSignin': 'Check-in Harian',
  'pageTitle.taskCenter': 'Pusat Tugas',
  'pageTitle.taskEmail': 'Ikat Email',
  'pageTitle.taskShare': 'Berbagi untuk Hadiah',
  'pageTitle.appApplyRecord': 'Catatan Aplikasi',
};
const Common = {
  'common.ok': 'OK',
  'common.confirm': 'Konfirmasi',

  'common.cancel': 'Batal',
  'common.avatar': 'Avatar',
  'common.iSee': 'Saya mengerti',
  'common.human': 'Orang',
  'common.requreUpdate': 'Versi saat ini terlalu lama, harap perbarui ke versi terbaru.',
  'common.currency.dollar': 'Dolar',
  'common.free': 'Gratis',
  'common.currency.rmb': 'Yuan',
  'common.init': 'Menginisialisasi proyek',
  'common.payType.offline': 'Pembayaran offline',
  'common.payType.alipay': 'Alipay',
  'common.payType.wxMiniProg': 'Program Mini WeChat',
  'common.payType.wx': 'WeChat', //WeChat Pay',
  'common.payType.bank': 'Kartu Bank/Kartu Kredit', //Kartu Bank/Kartu Kredit',
  'common.selectPlaceholder': 'Tidak dipilih',
  'common.loading': 'Memuat',
  'common.noMore': 'Tidak ada lagi',
};
const Tips = {
  'tips.pleaselogin': 'Silakan masuk terlebih dahulu',
  'tips.pleaselogin.event': 'Anda bisa ikut acara setelah masuk~',
  'tips.gologin': 'Pergi ke login',
  'tips.loadFailed': 'Gagal memuat',
  'tips.listLoadFailed': 'Gagal memuat daftar',
  'tips.loadFailed.retry': 'Gagal memuat, silakan coba lagi nanti',
  'tips.refreshed': 'Diperbarui',
  'tips.refreshFailed': 'Kesalahan penyegaran',
  'tips.saving': 'Menyimpan...',
  'tips.saveQrcode': 'Simpan kode QR',
  'tips.copyed': 'Berhasil disalin',
  'tips.loadingHard': 'Memuat dengan putus asa, harap tunggu...',
  'tips.loading': 'Memuat...',
  'tips.nodata.forNow': 'Tidak ada data tersedia',
  'tips.load.success': 'Pemuatan selesai',
  'tips.goingToPay': 'Sedang menuju pembayaran...',

  'tips.cancelSuccessful': 'Dibatalkan dengan sukses',
  'tips.failToRefreshOrder': 'Pembaruan pesanan gagal',
  'tips.refreshOrderError': 'Kesalahan saat memperbarui pesanan',
  'tips.refreshListError': 'Kesalahan saat memperbarui daftar',
  'tips.refreshListDone': 'Daftar telah diperbarui',
  'tips.pull2Refresh': 'Tarik ke bawah untuk menyegarkan',
  'tips.release2Refresh': 'Lepaskan untuk menyegarkan',
  'tips.refreshing': 'Menyegarkan',
};
// 开通记录
const ActivationRecord = {
  'record.records': 'Catatan aktivasi',
  'record.options': 'Operasi',
  'record.memberRefund': 'Pengembalian dana anggota',
  'record.syncOrder': 'Sinkronkan pesanan',
  'record.tip': 'Pengingat yang Ramah',
  'record.tipDesc': 'Apakah Anda yakin ingin membatalkan layanan langganan bulanan QuickFox Super VIP? Ini akan menghentikan pembaruan akun Anda, dan Anda akan kehilangan akses ke rute eksklusif VIP setelah kedaluwarsa.',
  'record.memberPage.pageViewsOfActivationRecord': 'Halaman Keanggotaan - Tampilan Halaman Catatan Langganan',
  'record.refundFail.tryAgain': 'Permintaan pengembalian dana gagal, silakan coba lagi nanti.',
  'record.cancel': 'Batal',
  'record.noRecordYet.goAndActive': 'Belum ada catatan, segeralah menjadi anggota~',
  'record.chooseRefundOrder': 'Pilih Pesanan Pengembalian Dana',
  'record.weSupportRefund.oneUserHasOneService': 'Kami mendukung permintaan pengembalian dana dalam 7 hari setelah membeli keanggotaan Super VIP. Silakan pilih pesanan yang akan dikembalikan, dan dana akan dikembalikan ke metode pembayaran asli. Setiap pengguna hanya dapat menikmati layanan pengembalian dana sekali.',
  'record.failToGetList': 'Gagal mendapatkan daftar',
  'record.failToGetActivationList': 'Gagal mendapatkan daftar catatan aktivasi',
  'record.failToGetRefund': 'Gagal mendapatkan status pengembalian dana',
  'record.getListFail': 'Gagal mendapatkan daftar',
  'record.recordItem.numberOfRefund': 'Halaman Keanggotaan - Catatan Langganan, Klik Tombol Pengembalian pada Kartu Pesanan',
  'record.recordItem.getTime': 'Waktu Perolehan',
  'record.recordItem.refundTime': 'Waktu Pengembalian',
  'record.recordItem.refuseRefund': 'Tidak Dapat Dikembalikan',
  'record.recordItem.refundComplete': 'Pengembalian Selesai',
  'record.recordItem.addDay': 'Durasi Manfaat',

  'record.recordItem.handsel': 'Hadiah',
  'record.recordItem.orderNumber': 'Nomor Pesanan',
  'record.recordItem.orderType': 'Metode Pembayaran',
  'record.recordItem.orderNumberHasBeenCopied': 'Nomor Pesanan Disalin',
  'record.recordItem.refund': 'Pengembalian Dana',
  'record.recordItem.outActivity': 'Aktivitas Eksternal',
  'record.resaonModal.refundReason': 'Alasan Pengembalian Dana',
  'record.resaonModal.supplement': 'Catatan Tambahan',
  'record.resaonModal.refundReasonPlaceholder': 'Opsional. Beri tahu kami mengapa Anda membutuhkan pengembalian dana agar kami dapat mengoptimalkan secepat mungkin. Maksimal 50 karakter.',
  'record.resaonModal.reasonLimitedText': 'Maksimal 50 karakter yang diperbolehkan.',
  'record.resaonModal.failToSubmitRefundRequset': 'Pengajuan pengembalian dana gagal.',
  'record.resaonModal.refundApplication': 'Permintaan Pengembalian Dana',
  'record.reasonModal.failToRefund': 'Operasi gagal',
  'record.reasonModal.successfulRefund': 'Operasi berhasil',
  'record.reasonModal.weSupportRefund.reviewDetailonITunes': 'Kami mendukung permintaan pengembalian dana dalam 7 hari setelah membeli keanggotaan Super VIP. Silakan periksa pesanan di iTunes dan ajukan permintaan pengembalian dana.',
  'record.reasonModal.numberOfConfirmRefund': 'Halaman keanggotaan - Halaman catatan aktivasi, Konfirmasi klik tombol pengembalian dana',
  'record.reasonModal.ok': 'Baik',
};
// 时间类型(通用)
const TimeType = {
  'timeType.day': 'Hari',
  'timeType.week': 'Minggu',
  'timeType.month': 'Bulan',
  'timeType.season': 'Musim',
  'timeType.year': 'Tahun',
  'timeType.minute': 'Menit',
  'timeType.hour': 'Jam',
  'timeType.sentence': '{day} hari {hour} jam {minute} menit {second} detik',
};
// 防锁定教程
const tutorial = {
  'tutorial.mi': 'Tutorial Ponsel Xiaomi',
  'tutorial.vivo': 'Tutorial Ponsel vivo',
  'tutorial.oppo': 'Tutorial Ponsel OPPO',
  'tutorial.huawei': 'Tutorial Ponsel Huawei',
  'tutorial.honor': 'Tutorial Ponsel Honor',

  'tutorial.oneplus': 'Tutorial Ponsel OnePlus',
  'tutorial.samsung': 'Tutorial Ponsel Samsung',
  'tutorial.general': 'Tutorial Ponsel Lainnya',
  'tutorial.tips': 'Silakan pilih merek ponsel Anda untuk melihat tutorial yang sesuai',
  'tutorial.title': 'Tutorial Percepatan & Anti-Putus',
  'tutorial.purchase.title': 'Beli Super VIP',
  'tutorial.purchase.content0': 'Jika Anda tidak dapat menyelesaikan pembayaran saat membeli keanggotaan melalui Google Play, Anda dapat mencoba metode berikut:',
  'tutorial.purchase.title1': '1. Beli keanggotaan di situs web resmi',
  'tutorial.purchase.content1': 'Anda dapat mengklik tombol di bawah untuk membeli keanggotaan di situs web resmi, mendukung WeChat/Alipay/PayPal dan metode pembayaran lainnya dengan harga yang lebih baik;',
  'tutorial.purchase.title2': '2. Instal versi terbaru QuickFox',
  'tutorial.purchase.content2': 'Anda dapat mengunduh versi terbaru dari situs web resmi QuickFox, mendukung WeChat/Alipay/PayPal dan metode pembayaran lainnya;',
  'tutorial.purchase.title3': '3. Hubungi layanan pelanggan untuk membeli',
  'tutorial.purchase.content3': 'QuickFox mendukung pembelian Super VIP melalui WeChat/Alipay/bank dengan memindai kode QR atau transfer. Anda dapat mengklik sudut kiri atas aplikasi untuk berkonsultasi dengan layanan pelanggan atau menambahkan akun WeChat resmi QuickFox2020 untuk pertanyaan.',
  'tutorial.purchase.button': 'Beli di situs web resmi',
  'tutorial.purchase.button1': 'Unduh versi terbaru',
};
// 邀请裂变1, 2期活动结束
const pointEventEnd = {
  'pointEventEnd.tooltipText': 'Sayangnya, acara telah berakhir',
  'pointEventEnd.invitationWithPrize': 'Undang dan dapatkan hadiah',
  'pointEventEnd.scanQRToFollow': 'Pindai kode QR untuk mengikuti akun resmi, sampai jumpa lagi~',
  'pointEventEnd.scanQRToFollowForMoreInfo': 'Scan untuk mengikuti akun resmi QuickFox untuk pembaruan acara yang lebih menarik.',
  'pointEventEnd.copyOfficialAccount': 'Salin akun resmi',
};
// 邀请裂变第3期
const taskCenterV3 = {
  'task.mission.pv': 'Tampilan halaman pusat tugas',
  'task.lookforwardForMoreTasks': 'Lebih banyak tugas segera hadir',
  'task.taskCard.isPcAppNotice': 'Tugas undangan saat ini hanya didukung di perangkat seluler. Silakan pindai kode QR untuk mengunduh Aplikasi QuickFox untuk menyelesaikan tugas.',
  'task.taskCard.numberOfInvitationClick': 'Klik tugas undangan',
  'task.taskCard.numberOfFollowTaskClick': 'Klik Tugas Akun Resmi',
  'task.taskCard.numberOfCheckInClick': 'Halaman Kesejahteraan, Klik Tugas Check-in',
  'task.detail.follow.numberOfFollowPage': 'Tayangan Halaman Tugas Akun Resmi',
  'task.invite.invitePagePv': 'Tayangan Halaman Tugas Undangan',
  'task.invite.cpoyPv': 'Klik Tautan Undangan Salin',
  'task.invite.loadingText': 'Belum ada catatan, undang teman sekarang~',


  'task.invite.nodataText': 'Belum ada catatan, cepat selesaikan tugas untuk mendapatkan koin~',
  'task.invite.noContentText': 'Belum ada catatan',
  'task.invite.noContentTextPart1': 'Cepat undang teman sekarang',
  'task.invite.coinDetail': 'Detail koin',
  'task.invite.coinDetailPv': 'Tayangan halaman detail koin',
  'task.invite.numberOfClickInviteBtn': 'Jumlah klik tombol undangan',
  'task.invite.posterAndFace2Face': 'Poster & Undangan Tatap Muka',
  'task.invite.inviteForNow': 'Undang Sekarang',
  'task.invite.linkCopied': 'Tautan Disalin',
  'task.invite.posterLoading': 'Poster Sedang Dimuat...',
  'task.invite.descript.title.part1': 'Untuk setiap teman yang diundang, Anda bisa mendapatkan hingga',
  'task.invite.descript.title.part2': 'Ayo Undang Sekarang',
  'task.invite.reward.descrip': 'Hadiah',
  'task.invite.reward.descrip.part1': '1. Setelah teman yang diundang menggunakan akselerasi sekali di terminal seluler, teman Anda bisa mendapatkan hadiah waktu VIP selama 30 menit.',
  'task.invite.reward.descrip.part2': '2. Setelah teman yang Anda undang menyelesaikan pembelian VIP, Anda akan menerima 10% dari durasi pembelian mereka sebagai hadiah undangan.',
  'task.invite.reward.descrip.part3': '3. Pendaftaran massal dengan cara tidak adil akan dianggap sebagai pelanggaran dan tidak akan mendapatkan hadiah undangan.',
  'task.invite.reward.descrip.part4': '4. Jika teman melakukan pengembalian dana, hadiah undangan yang Anda dapatkan akan dibatalkan.',
  'task.invite.reward.descrip.part5': '2. Ketika teman yang Anda undang menyelesaikan pembelian VIP, Anda akan menerima 10% + 5% dari durasi pembelian mereka sebagai hadiah.',
  'task.invite.details.tab.waitingData': 'Menunggu Akselerasi',
  'task.invite.details.tab.waitingToGiveData': 'Menunggu Distribusi',
  'task.invite.details.tab.completedData': 'Selesai',
  'task.invite.details.tab.inValidData': 'Kedaluwarsa',
  'task.invite.details.tab.closed': 'Ditutup',
  'task.invite.details.tab.toAppeal': 'Menunggu Banding',
  'task.invite.details.tab.toPaid': 'Pembayaran Tertunda',
  'task.invite.details.tab.violationData': 'Pengguna Melanggar',
  'task.invite.details.content.type1': 'Teman Anda telah menyelesaikan pendaftaran. Minta mereka mengunduh aplikasi di perangkat baru dan menggunakan akun tersebut untuk peningkatan kecepatan. Hadiah akan tiba dalam waktu 1 jam.',
  'task.invite.details.content.type2': 'Teman telah berhasil diundang, dan hadiah waktu VIP 30 menit telah diberikan kepada teman tersebut.',
  'task.invite.details.content.type3': 'Ups, teman ini tidak melakukan peningkatan kecepatan pertama di perangkat baru. Undangan ini gagal~',
  'task.invite.details.content.type4': 'Teman telah berhasil diundang, dan peninjauan risiko sistem sedang berlangsung. Hadiah waktu VIP 30 menit teman Anda akan dikreditkan ke akun Anda dalam waktu 1 jam.',

  'task.invite.details.content.type5': 'Teman ini melanggar aturan, hadiah tidak dapat diberikan',
  'task.invite.details.loading': 'Detail undangan sedang dimuat...',
  'task.invite.details.load.faild': 'Gagal memuat detail undangan',
  'task.signin.viewPv': 'Kesejahteraan - Halaman Check-in, Tampilan Halaman',
  'task.signin.walfare': 'Manfaat Check-in Pengguna Baru',
  'task.signin.walfare.detail': 'Dalam 7 hari pertama setelah mendaftar melalui undangan teman, check-in selama 3 hari berturut-turut untuk menerima tambahan 100 koin emas. Anda juga bisa bergabung dalam kampanye undangan, mengundang teman untuk check-in bersama, dan mendapatkan hadiah koin emas check-in yang sama.',
  'task.signin.walfare.downloadForSignin': 'Scan untuk mengunduh QuickFox APP dan mengundang teman untuk check-in',
  'task.signin.walfare.goToInviteWithPhone': 'Pergi ke ponsel untuk mengundang',
  'task.signin.walfare.goToInvite': 'Pergi untuk mengundang >',
  'task.signin.walfare.numberOfCheckInClick': 'Manfaat - Halaman tugas check-in, klik check-in',
  'task.signin.walfare.signing': 'Data check-in sedang dimuat, harap tunggu...',
  'task.signin.walfare.signSuccessTipsPart1': 'Check-in berhasil, {todayReward} koin emas diterima, ',
  'task.signin.walfare.signSuccessTipsPart2': 'Sebagai pengguna baru, Anda telah menerima manfaat check-in berkelanjutan, ini tambahan 100 koin untuk Anda~',
  'task.signin.walfare.signSuccessTipsPart3': 'Jangan lupa datang setiap hari~',
  'task.goods.detail.title': 'Detail Produk',
  'task.goods.detail.lessCoin': 'Koin Tidak Cukup',
  'task.goods.detail.lessCoinTips': 'Anda tidak memiliki cukup koin, selesaikan tugas untuk mendapatkan lebih banyak~',
  'task.goods.detail.lessCoinTips.goForMoreCoin': 'Anda tidak memiliki cukup koin, selesaikan tugas untuk mendapatkan lebih banyak~Perangkat iOS saat ini tidak mendukung pengisian selisih, lakukan penukaran di perangkat sistem lain',
  'task.goods.detail.exchangeRes.goCheck': 'Tukar berhasil, Anda dapat memeriksa dan menerima produk di halaman "Catatan Penukaran".',
  'task.goods.detail.exchange': 'Tukar Produk',
  'task.goods.detail.exchangeSuccessful': 'Penukaran Berhasil',
  'task.goods.detail.exchangeSuccessful.congratulate': 'Selamat, Anda telah berhasil menukar, Anda dapat menerima produk melalui cara berikut~',
  'task.goods.detail.exchangeSuccessful.tips': 'Selamat, aplikasi penukaran Anda telah berhasil, kami akan menyelesaikan tinjauan dalam 2 hari kerja, Anda dapat memeriksa kemajuan di halaman "Catatan Penukaran"~',
  'task.goods.detail.exchangeSuccessful.getVip': 'Tukar berhasil, hak istimewa Super VIP telah diisi ulang ke akun Anda.',
  'task.goods.detail.exchange.fail.retry': 'Pertukaran gagal, silakan coba lagi nanti',
  'task.goods.detail.exchangeConfirm': 'Apakah Anda yakin untuk menukar produk ini?',
  'task.goods.detail.stock.less': 'Stok tidak mencukupi',
  'task.goods.detail.stock.less.tips': 'Stok produk ini tidak mencukupi, sementara tidak dapat ditukar~',
  'task.goods.detail.signinDay.less': 'Hari check-in tidak mencukupi',
  'task.goods.detail.signinDay.less.tips': 'Produk ini memerlukan {day} atau lebih check-in untuk ditukar, cepat check-in~',

  'task.goods.detail.remain': 'Tersisa',
  'task.goods.detail.tillNext': 'Menuju flash sale berikutnya dalam',
  'task.goods.blockTitle': 'Pengantar Produk',
  'task.goods.noStock': 'Stok Habis',
  'task.goods.noConvertible': 'Tidak Dapat Ditukar',
  'task.goods.overConvertibleLimit': 'Batas Penukaran Telah Dicapai',
  'task.goods.exchange.now': 'Tukar Sekarang',
  'task.goods.order.total': 'Total Pesanan',
  'task.goods.coinForPay': 'Bayar dengan Koin',
  'task.goods.require.diff': 'Perlu Tambahan Harga',
  'task.goods.pay.diff': 'Bayar Selisih',
  'task.goods.pay.diff.exchange': 'Bayar Selisih untuk Menukar',
  'task.goods.pay.way': 'Pilih Metode Pembayaran',
  'task.goods.contact.offcialAccount': 'Hubungi Layanan Pelanggan QuickFox WeChat {number}',
  'task.goods.offcialAccount.copy': '(Klik untuk Menyalin ID WeChat)',
  'task.goods.contact.customerService': 'Hubungi Layanan Pelanggan QuickFox WeChat',
  'task.goods.go': 'Pergi Sekarang',
  'task.point.detail.coinType0': 'Lotere Koin',
  'task.point.detail.coinType1': 'Tukar Koin',
  'task.point.detail.coinType2': 'Undang teman {account} untuk mendaftar',
  'task.point.detail.coinType3': 'Daftar melalui undangan teman',
  'task.point.detail.coinType4': 'Hadiah platform untuk pengguna peringkat atas',
  'task.point.detail.coinType5': 'Check-in Harian',
  'task.point.detail.coinType6': 'Ikuti Akun Resmi WeChat',
  'task.point.detail.coinType7': 'Pesanan penukaran mal kedaluwarsa',
  'task.point.detail.coinType8': 'Pendapatan undian koin emas',
  'task.point.detail.coinType9': 'Hadiah tambahan untuk check-in 3 hari berturut-turut',
  'task.point.detail.coinType10': 'Hadiah tambahan untuk check-in 3 hari berturut-turut teman',
  'task.point.detail.bindReward': 'Hadiah ikatan',
  'task.point.detail.shareReward': 'Hadiah tugas berbagi',

  'task.point.detail.coinType11': 'Giveaway Koin Emas Festival Musim Gugur',
  'task.point.detail.coinType13': 'Koin Emas Kedaluwarsa',
  'task.point.detail.coinType16': 'Acara Tebak Piala Dunia',
  'task.redeem.modal.title': 'Belum Didukung',
  'task.redeem.modal.content': 'Perangkat iOS saat ini tidak mendukung pertukaran top-up. Silakan lakukan pertukaran di perangkat sistem lain.',
  'task.redeem.exchangeRecordPv': 'Tayangan Catatan Pertukaran',
  'task.redeem.exchangeRecord': 'Catatan Penukaran',
  'task.redeem.exchangeCode': 'Kode Penukaran:',
  'task.redeem.draw.link': 'Tautan Klaim:',
  'task.redeem.draw.code': 'Kode Klaim Produk:',
  'task.redeem.exchangeCode.use': 'Metode Penukaran',
  'task.redeem.norecord.goForIt': 'Belum ada catatan, cepat tukar beberapa produk~',
  'task.redeem.record.tips': 'QuickFox akan menyelesaikan distribusi dalam 2 hari kerja (Senin hingga Jumat adalah hari kerja). Harap periksa dan gunakan segera setelah distribusi.',
  'task.redeem.clickForIt': 'Klik di sini untuk melihat',
  'task.redeem.copy': 'Salin',
  'task.redeem.copied': 'Tersalin',
  'task.redeem.payForNow': 'Bayar Sekarang',
  'task.redeem.orderWill': 'Pesanan akan kedaluwarsa pada {time}, harap bayar tepat waktu.',
  'task.redeem.dataReady': 'Data sedang dipersiapkan, harap tunggu...',
  'task.redeem.drawed': 'Menang',
  'task.redeem.receive': 'Klaim Sekarang',
  'task.redeem.drawed.limitDate': 'Hadiah berlaku hingga',
  'task.redeem.drawed.waitForit': 'Menang {lotteryName}, menunggu distribusi (akan selesai dalam 2 hari kerja)',
  'task.redeem.drawed.waitForit.physical': 'Menang {lotteryName}, silakan hubungi layanan pelanggan WeChat chenhan_xy untuk klaim',
  'task.redeem.drawed.violation': 'Memenangkan {lotteryName}, pesanan telah ditutup karena pelanggaran.',
  'task.redeem.drawed.success': 'Memeriksa {lotteryName}, keanggotaan telah diisi ulang ke akun Anda, harap periksa.',
  'task.redeem.drawed.goods.success': 'Memeriksa {lotteryName}, telah diisi ulang ke akun Anda, harap periksa.',
  'task.redeem.drawed.goods.success.physical': 'Memeriksa {lotteryName}, hadiah telah didistribusikan.',
  'task.redeem.drawed.svip.success': 'Keanggotaan Super VIP telah diisi ulang ke akun Anda, harap periksa.',
  'task.redeem.drawed.vip.success': 'Keanggotaan VIP telah diisi ulang ke akun Anda, harap periksa.',

  'task.redeem.drawed.violation.closed': 'Pesanan ditutup karena pelanggaran',
  'task.redeem.violation.contact': 'Koin pelanggaran, tidak ada hadiah undian. Untuk pertanyaan, email info@quickfox.com.cn.',
  'task.redeem.limit.contact': 'Karena operasi tidak normal pada akun yang diundang, penukaran dibatasi sementara. Kirim materi banding ke info@quickfox.com.cn. Sertakan akun QuickFox dan catatan obrolan dengan semua teman yang diundang baru-baru ini.',
  'task.redeem.order.fail': 'Pesanan ini telah kedaluwarsa, dan koin yang digunakan telah dikembalikan ke akun Anda.',
  'task.redeem.draw.customer.service': 'Periksa detail dan tambahkan WeChat untuk menukarkan.',
  'task.redeem.drawLink.tips': 'Tautan klaim: Menunggu distribusi (akan selesai dalam 2 hari kerja)',
  'task.redeem.drawLink.limit.tips': 'Kode produk akan kedaluwarsa pada {expireTime}, harap tukarkan secepat mungkin.',
  'task.redeem.noname': 'Belum ada nama',
  'task.redeem.checkMethod': 'Lihat metode penukaran',
  'task.redeem.invite.reward': '邀请有礼',
  'task.redeem.follow.reward': '关注公众号',
  'task.redeem.bind.reward': '绑定手机/邮箱',
  'task.redeem.signin.reward': '每日签到',
  'task.redeem.intlAuth.reward': '留学认证奖励',
  'task.redeem.coin.reward': '金币兑换',
  'task.redeem.game.reward': '小游戏奖励',

  'task.event.rule': 'Aturan acara',
  'task.event.question': 'FAQ',
  'task.event.needToKnow': 'Pemberitahuan acara',
  'task.goods.loadGoods.fail': 'Gagal memuat daftar produk',
  'task.goods.coin.loadFailed': 'Gagal memuat koin emas',
  'task.goods.shop.requreUpdate': 'Akses mall koin emas tidak normal, harap tingkatkan ke klien terbaru untuk pengalaman pengguna yang lebih baik',
  'task.goods.coin.less.loadFailed': 'Kesalahan memuat sisa koin emas',
  'task.goods.coin.balance': 'Saldo koin emas',
  'task.goods.coin.detail.view': 'Lihat catatan transaksi koin emas',
  'task.goods.coin.exchange.record': 'Lihat Pesanan Penukaran Mall',
  'task.lottery.detailPv': 'Tampilan Halaman Detail Produk Undian',
  'task.lottery.waitMsg': 'Sedang mengundi, tunggu sebentar, hasilnya akan segera diumumkan~',
  'task.lottery.drawOut': 'Hadiah sudah habis, sedang mengisi ulang hadiah, silakan kembali nanti~',
  'task.lottery.networkErrMsg': 'Kesalahan jaringan, harap periksa jaringan Anda dan coba lagi~',
  'task.lottery.Replenishment': 'Hadiah sudah habis, sedang mengisi ulang hadiah, silakan kembali nanti~',
  'task.lottery.balance.lessMsg': 'Koin emas tidak cukup, cepat dapatkan koin emas~',
  'task.lottery.forAWhile': 'Saat ini tidak bisa mengundi, coba lagi nanti~',
  'task.lottery.luckyId.error': 'Kesalahan ID kemenangan:',
  'task.lottery.luckyId.cannotFind': 'Hadiah tidak ditemukan, ID kemenangan adalah:',
  'task.lottery.interrupt': 'Aduh, undian terhenti secara tidak terduga! Silakan coba lagi nanti atau hubungi layanan pelanggan',
  'task.lottery.start.first': 'Silakan mulai dulu',

  'task.lottery.number.error': 'Kesalahan Angka',
  'task.lottery.now': 'Segera',
  'task.lottery': 'Undian Berhadiah',
  'task.lottery.add': 'Suplemen',
  'task.lottery.rewards': 'Dalam Hadiah',
  'task.lottery.draw.congratulate': 'Selamat! Anda menang',
  'task.lottery.coin.once': 'Koin/waktu',
  'task.lottery.draw.view': 'Anda dapat mengklaimnya setelah sistem mendistribusikannya, dan memeriksa kemajuannya di halaman "Kesejahteraan - Catatan Penukaran".',
  'task.lottery.draw.viewReward': 'Hadiah telah dikirim ke akun Anda, Anda dapat memeriksanya di halaman "Kesejahteraan - Catatan Penukaran".',
  'task.lottery.draw.physicalGoods': 'Silakan hubungi layanan pelanggan tepat waktu untuk mengklaimnya, dan periksa informasi kontak dan kemajuan di halaman "QuickFox App - Kesejahteraan - Catatan Penukaran"~',
  'task.lottery.rule': 'Aturan Lotere',
  'task.lottery.rulePv': 'Klik Aturan Lotere',
  'task.lottery.myRewardPv': 'Klik Hadiah Saya',
  'task.lottery.tab.item1.part1': 'Acara',
  'task.lottery.tab.item1.part2': 'Aturan',
  'task.lottery.tab.item2.part1': 'Saya',
  'task.lottery.tab.item2.part2': 'Hadiah',
  'task.lottery.coin.earnIt': 'Dapatkan Koin>>',
  'task.lottery.more': 'Lebih Banyak Undian',
  'task.lottery.result': 'Hasil Undian',
  'task.lottery.again': 'Undi Lagi',
  'task.lottery.toView': 'Lihat',
  'task.lottery.lickDrawNowPv': 'Klik Sukses pada Tombol "Undi Sekarang"',
  'task.lottery.error': 'Kesalahan Undian:',
  'task.lottery.notLogin': 'Belum Masuk',
  'task.walfare.center': 'Pusat Kesejahteraan',
  'task.walfare.info.refresh.done': 'Informasi Pribadi Diperbarui',
  'task.walfare.info.refresh.error': 'Kesalahan Memperbarui Informasi Pribadi',
  'task.walfare.refreshed': 'Diperbarui',
  'task.walfare.refresh.error': 'Kesalahan Memperbarui',

  'task.walfare.viewPv': 'Tayangan Halaman Kesejahteraan',
  'task.walfare.all': 'Semua',
  'task.walfare.giftMoney': 'Amplop Merah',
  'task.walfare.coin.clickPv': 'Klik Detail Koin Emas',
  'task.walfare.coin.left': 'Koin Emas yang Tersisa',
  'task.walfare.coin.mine': 'Koin Emas Saya',
  'task.walfare.coin.expire.thisMonth': 'Koin Kedaluwarsa Bulan Ini',
  'task.walfare.coin.expire.time': 'Waktu Kedaluwarsa',
  'task.walfare.coin.earn': 'Dapatkan Koin',
  'task.walfare.exchange.record': 'Catatan Penukaran',
  'task.walfare.exchange.recordPv': 'Jumlah Klik Catatan Penukaran',
  'task.walfare.coin.descrip': 'Petunjuk Koin',
  'task.walfare.coin.descrip.usage': 'Untuk apa koin digunakan?',
  'task.walfare.coin.descrip.usage.part1': 'Koin adalah aset mata uang virtual Anda di QuickFox, dapat ditukar dengan hadiah seperti voucher tunai dan keanggotaan VIP.',
  'task.walfare.coin.descrip.channel': 'Cara dapat koin',
  'task.walfare.coin.descrip.channel.part1': 'Dapatkan koin dengan menyelesaikan tugas seperti check-in harian, mengundang teman, dan mengikuti akun resmi QuickFox.',
  'task.walfare.coin.descrip.expire': 'Pemberitahuan kedaluwarsa koin emas:',
  'task.walfare.coin.descrip.expire.part1': 'Koin yang dihasilkan setiap bulan akan kedaluwarsa setelah 3 bulan. Koin yang akan kedaluwarsa bulan ini akan masuk ke daftar koin yang akan kedaluwarsa, dan koin yang akan kedaluwarsa akan diprioritaskan untuk penukaran. Jika tidak ditukar tepat waktu, koin akan kedaluwarsa dan tidak dapat dipulihkan.',
  'task.walfare.coin.noticePv': 'Klik Pengumuman',
  'task.walfare.detail.view': 'Lihat Detail',
  'task.walfare.tasks.more': 'Tugas Lainnya',
  'task.walfare.tasks.clickPv': 'Klik Tugas Lainnya',
  'task.goods.clickPv': 'Klik Produk',
  'welfare.invitev2.page.title': 'Berikan VIP ke teman Anda',
  'welfare.invitev2.page.getFail': 'Gagal mengambil data',
  'welfare.invitev2.page.directions': 'Pengingat ramah: Setelah mengaktifkan kuota hadiah gratis, pesanan berbayar terbaru Anda akan kehilangan kelayakan pengembalian dana tanpa alasan 7 hari.',
  'welfare.invitev2.rule.title': 'Aturan Hadiah',
  "welfare.invitev2.rule.content": `
    1. Pengguna VIP bisa aktifkan & klaim 3 kuota undangan/bulan (pernah beli membership, sisa masa berlaku >30 hari saat aktivasi; pengguna langganan otomatis harus perpanjang 2 bulan berturut-turut tanpa refund/pembatalan). Bagikan link ke teman, setelah daftar bisa klaim membership QuickFox sesuai durasi;<br/>
    2. Setiap aktivasi kuota akan batalkan hak refund 7 hari untuk pesanan terbaru. Pastikan setuju sebelum aktivasi;<br/>
    3. 1 nomor HP hanya bisa klaim 1x membership 15 hari;<br/>
    4. QuickFox berhak cabut hak istimewa & batalkan transaksi jika ditemukan penyalahgunaan/transfer keuntungan ilegal;<br/>
    5. Untuk bantuan, hubungi CS QuickFox. Aktivitas ini tidak terkait Apple Inc.;<br/>
    6. QuickFox memiliki hak interpretasi akhir sesuai hukum yang berlaku;`,
  'welfare.invitev2.link.title': 'Hadiahkan Anda kartu keanggotaan QuickFox',
  'welfare.invitev2.link.descrip': 'QuickFox Return Accelerator, merek pilihan utama untuk akselerasi pulang ke Tiongkok, mempercepat satu langkah lebih dulu',
  'welfare.invitev2.card.type': 'QuickFox VIP',

  'welfare.invitev2.card.nocheck': 'Tidak Diklaim',
  'welfare.invitev2.card.sendTo': 'Berhasil diberikan kepada teman dengan akhiran {account}',
  'welfare.invitev2.msgs.title': 'Kirim Pesan ke Teman',
  'welfare.invitev2.msgs.next': 'Mengalihkan',
  'welfare.invitev2.btn.allCheck': 'Semua kartu keanggotaan telah diklaim oleh teman',
  'welfare.invitev2.btn.giftNow': 'Hadiah sekarang',
  'welfare.invitev2.btn.timeEnd': 'Waktu hadiah telah berakhir',
  'welfare.invitev2.btn.submitAgain': 'Meminta untuk melanjutkan hadiah',
  'welfare.invitev2.btn.upgradeToVip': 'Tingkatkan ke VIP',
  'welfare.invitev2.btn.leftTime': 'Sisa waktu hadiah',
  'welfare.invitev2.btn.copyLink': 'Salin tautan berbagi',
  'welfare.invitev2.btn.copied': 'Tautan hadiah telah disalin',
  'welfare.invitev2.modal.cantGift': 'Saat ini tidak dapat memberikan keanggotaan',
  'welfare.invitev2.modal.content':
    'Jika ketentuan hadiah tidak terpenuhi saat ini, Anda dapat pergi ke pusat anggota untuk menambah waktu keanggotaan dan kemudian menghadiahkan keanggotaan tersebut kepada teman Anda. ',
  'welfare.invitev2.modal.getIt': 'Aturan',
  'welfare.invitev2.modal.buyVip': 'Beli keanggotaan sekarang',
  'task.detail.email.title': 'Lengkapi Profil',
  'task.detail.email.rule1': 'Aturan acara',
  'task.detail.email.rule2': 'Pengguna dapat menerima hadiah dengan mengikat email atau nomor telepon',
  'task.detail.email.rule3': 'Hadiah acara ini hanya dapat diklaim sekali dan tidak dapat diulang',
  'task.detail.email.rule4': 'Pengguna yang telah mengikat email atau nomor telepon dapat langsung menerima hadiah acara di halaman ini. Pengguna yang mendaftar melalui email atau nomor telepon akan secara otomatis menerima hadiah',
  'task.detail.email.rule5': 'Durasi hadiah akan dikreditkan secara real time. Kode kupon dikirim melalui email atau SMS, dan hanya dapat digunakan melalui URL pendek dalam pesan',
  'task.detail.email.btn': 'Ikat dan Klaim',
  'task.detail.email.received': 'Sudah Diklaim',
  'task.detail.email.finished': 'Acara telah berakhir',
  'task.detail.email.bind': 'Ikat Sekarang',
  'task.detail.email.bound': 'Klaim Sekarang',
  'task.detail.email.success': 'Berhasil Diklaim',
  'task.detail.email.failed': 'Klaim Gagal',
  'task.detail.email.verify.pleaseEnterCorrectEmail': 'Masukkan alamat email yang valid',

  'task.detail.email.verify.pleaseEnterEmail': 'Silakan masukkan alamat email Anda',
  'task.detail.email.verify.pleaseEnterCorrectPhone': 'Silakan masukkan nomor telepon yang valid',
  'task.detail.email.verify.pleaseEnterPhone': 'Silakan masukkan nomor telepon Anda',
  'task.detail.email.verify.pleaseEnterCorrectVerifyCode': 'Silakan masukkan kode verifikasi yang valid',
  'task.detail.email.verify.pleaseEnterVerifyCode': 'Silakan masukkan kode verifikasi',
  'task.detail.email.verify.pleaseEnterDigitPsw': 'Silakan masukkan kata sandi kombinasi angka dan huruf 6-16 digit',
  'task.detail.share.title': 'Berbagi untuk Hadiah',
  'task.detail.share.min5m': 'Silakan pilih gambar yang lebih kecil dari 5M',
  'task.detail.share.noPass': 'Tidak lulus peninjauan, kirim ulang',
  'task.detail.share.submit': 'Ajukan untuk Ditinjau',
  'task.detail.share.underReview': 'Sedang Ditinjau',
  'task.detail.share.pass': 'Disetujui, hadiah telah diberikan',
  'task.detail.share.save': 'Simpan Gambar',
  'task.detail.share.cancel': 'Batal',
  'task.detail.share.noUpload': 'Harap unggah tangkapan layar berbagi terlebih dahulu!',
  'task.detail.share.saveSuccess': 'Gambar telah disimpan ke album',
  'task.detail.share.saveFail': 'Gagal menyimpan gambar!',
  'task.detail.share.successTip': 'Telah diajukan untuk ditinjau, harap bersabar',
  'task.detail.share.version': 'Versi saat ini rendah, silakan pergi ke halaman "Saya - Akun Saya" untuk menyelesaikan pengikatan',
  'task.detail.share.message': 'Silakan unggah gambar!',
};

// 邀请裂变第4期
const pointEventV4 = {
  // 福利中心首页
  'V4.welfare.center.title': 'Pusat Kesejahteraan',
  'V4.welfare.center.more': 'Lebih Banyak Manfaat',
  'V4.welfare.foreignStudent.title': 'Manfaat Pelajar Internasional',
  'V4.welfare.foreignRule.title': 'Aturan',
  'V4.welfare.redeem.norecord.goForIt': 'Belum ada catatan, cepat dapatkan manfaatnya~',

  'V4.welfare.record.title': 'Catatan Manfaat',
  'V4.welfare.miniGame.title': 'Tugas Permainan Kecil',

  'V4.welfare.tasks.invite': 'Undang Teman',
  'V4.welfare.tasks.wx': 'Ikuti Akun Resmi',
  'V4.welfare.tasks.email': 'Ikat Telepon/Email',
  'V4.welfare.tasks.sign': 'Check-in Harian',
  'V4.welfare.tasks.exchange': 'Tukarkan Koin',

  'V4.welfare.tasks.invite.desc': 'Undang teman untuk mendapatkan 10% dari waktu yang mereka beli',
  'V4.welfare.tasks.wx.desc': 'Ikuti QuickFox untuk VIP 2 jam',
  'V4.welfare.tasks.email.desc': 'Ikat akun Anda untuk mendapatkan VIP selama 2 jam',
  'V4.welfare.tasks.sign.desc': 'Check-in berkelanjutan memperoleh waktu VIP',
  'V4.welfare.tasks.exchange.desc': 'Penukaran koin satu kali',

  'V4.welfare.tasks.invite.btn': 'pergi',
  'V4.welfare.tasks.sign.btn': 'pergi',
  'V4.welfare.tasks.exchange.btn': 'pergi',
  'V4.welfare.tasks.hot': 'Tugas yang sedang hangat',
  'V4.welfare.tasks.completed': 'pergi',
  'V4.welfare.tasks.goForIt': 'pergi',
  'V4.welfare.tasks.exchanged': 'pergi',
  'V4.welfare.tasks.goExchange': 'pergi',

  'V4.welfare.intlAuth.title': 'Otentikasi Mahasiswa Internasional',
  'V4.welfare.intlAuth.desc': 'Setelah menyelesaikan sertifikasi mahasiswa internasional, Anda dapat menikmati manfaat eksklusif untuk mahasiswa internasional di Pusat Kesejahteraan',
  'V4.welfare.intlAuth.btn': 'Klaim Manfaat',
  'V4.welfare.intlAuth.know': 'Tahu',
  'V4.welfare.intlAuth.goForItBtn': 'Otentikasi sekarang',

  'V4.welfare.vip.title': 'Hak istimewa VIP',
  'V4.welfare.vip.desc': 'Semua pengguna yang telah membeli keanggotaan QuickFoxVIP dan keanggotaannya belum kedaluwarsa memiliki hak istimewa VIP. Mereka dapat menerima manfaat eksklusif VIP di pusat kesejahteraan.',
  'V4.welfare.vip.btn': 'Perbarui durasi VIP',
  'V4.welfare.vip.know': 'Tahu',
  'V4.welfare.vip.upgrade': 'Tingkatkan sekarang',

  'V4.welfare.receive.record': 'Terima catatan',

  'V4.welfare.btn.receive': 'Ambil',
  'V4.welfare.btn.received': 'Diambil',
  'V4.welfare.btn.nextMonth': 'Ambil di bulan {month}',

  'V4.welfare.btn.monthWelfare': 'Manfaat bulan {month}',

  'V4.welfare.empty.noData': 'Belum ada data',
  'V4.welfare.btn.moreWelfare': 'Lebih banyak kesejahteraan >',

  // 福利详情页
  'V4.welfare.detail.title': 'Rincian kesejahteraan',
  'V4.welfare.detail.myRight': 'Hak saya',
  'V4.welfare.detail.welfareDesc': 'Deskripsi Kesejahteraan',
  'V4.welfare.detail.upgradeToVip': 'Tingkatkan ke VIP',
  'V4.welfare.detail.upgradeToVip.btn': 'Tingkatkan sekarang',
  'V4.welfare.detail.received': 'Sudah diklaim - Cek di riwayat',
  'V4.welfare.detail.nextMonth': 'Silakan kumpulkan pada {month}',
  'V4.welfare.detail.complete': 'Sertifikasi mahasiswa internasional lengkap',

  'V4.welfare.detail.received.success': 'Berhasil diterima, hak istimewa VIP telah diisi ulang ke akun Anda. Anda dapat mengunjungi halaman "Catatan Manfaat" untuk melihat hak istimewa yang diterima.',
  'V4.welfare.detail.received.goForIt': 'Lakukan Sekarang',
  'V4.welfare.detail.received.success.tip1': 'Berhasil diterima, buka halaman pembelian untuk menikmati diskon kesejahteraan. ',
  'V4.welfare.detail.received.success.tip2': 'Anda juga dapat membuka halaman "Saya" untuk melihat catatan koleksi~',
  'V4.welfare.detail.received.success.btn': 'Beli sekarang',
  'V4.welfare.detail.received.success.tip3': 'Berhasil diterima, kode produk: {key}\nAnda dapat membuka halaman "catatan kesejahteraan" untuk melihat hak istimewa yang diterima',
  'V4.welfare.detail.received.success.tip4': 'Tips: Anda dapat mengklik tautan pembelian di kotak surat otentikasi untuk langsung menggunakan kode produk untuk membeli~',

  'V4.welfare.detail.received.success.tip5': 'Pengingat hangat',
  'V4.welfare.detail.received.success.tip6': "Produk kesejahteraan {goodsName} memerlukan waktu VIP lebih dari {remainingTimeDaysMore} hari. Anda tidak memenuhi persyaratan untuk menerimanya sekarang. Apakah Anda ingin membeli keanggotaan sebelum menerimanya?' ",
  'V4.welfare.detail.received.success.btn2': 'Beli VIP',
  'V4.welfare.detail.received.success.title': 'Berhasil diterima',
  'V4.welfare.detail.received.success.tip7': 'Anda akan menerima kesejahteraan bulanan {thisMonth} sebagai pengguna umum. Anda bisa mendapatkan tingkat kesejahteraan yang lebih tinggi setelah meningkatkan ke VIP. Apakah Anda perlu melakukan peningkatan? ',
  'V4.welfare.detail.received.success.btn3': 'Peningkatan VIP',
  'V4.welfare.detail.received.failed': 'Gagal menerima',
  'V4.welfare.detail.received.success.btn4': 'Lanjut sebagai Basic',
  'V4.welfare.detail.received.success.tip8': 'Sudah diterima, mohon periksa di catatan tanda terima',
  // 暂停管理页
  'V4.welfare.pause.title': 'Mgt Pause penagihan',
  'V4.welfare.pause.rule': 'Aturan',
  'V4.welfare.pause.rule.title': 'Aturan jeda',
  'V4.welfare.pause.rule.know': 'Sudah dipahami',
  'V4.welfare.pause.resume': 'Lanjutkan penagihan',
  'V4.welfare.pause.pause': 'Jeda penagihan',
  'V4.welfare.pause.resume.tip': 'Membatalkan jeda terlebih dahulu tidak akan mengembalikan waktu jeda. Apakah Anda ingin melanjutkan? ',
  'V4.welfare.pause.resume.cancel': 'Batal',
  'V4.welfare.pause.resume.confirm': 'Konfirmasi',

  'V4.welfare.pause.select': 'Silakan pilih durasi jeda',
  'V4.welfare.pause.failed': 'Jeda gagal',

  'V4.welfare.pause.record': 'Catatan',

  'V4.welfare.pause.thisYear': 'Tahun ini',
  'V4.welfare.pause.remainCount': 'Jumlah jeda',
  'V4.welfare.pause.count': 'kali',
  'V4.welfare.pause.remainMon': 'Total durasi jeda',
  'V4.welfare.pause.month': 'Bulan',

  'V4.welfare.pause.myRight': 'Hak saya',
  'V4.welfare.pause.expiredTip': 'VIP Anda telah kedaluwarsa dan tidak dapat dijeda. Ayo',
  'V4.welfare.pause.buyGuide': 'Isi Ulang Keanggotaan',
  'V4.welfare.pause.buyGuide.tip': 'Ya~',
  'V4.welfare.pause.usedTip': 'Anda telah menggunakan waktu jeda tahunan atau durasinya dan tidak dapat berhenti lagi. ',

  'V4.welfare.pause.currentStatus': 'Status Keanggotaan',
  'V4.welfare.pause.status.pause': 'Penagihan dijeda',
  'V4.welfare.pause.tatus.normal': 'Penagihan normal',

  'V4.welfare.pause.pauseTimeType.minute': 'menit',
  'V4.welfare.pause.pauseTimeType.hour': 'jam',
  'V4.welfare.pause.pauseTimeType.day': 'Hari',
  'V4.welfare.pause.expired': 'VIP telah kedaluwarsa',
  'V4.welfare.pause.pauseTime': 'Jeda akan berlaku',
  'V4.welfare.pause.resumeTime': 'Lanjutkan penagihan setelah',
  'V4.welfare.pause.selectTip': 'Pilih durasi jeda penagihan',
  'V4.welfare.pause.selectPlaceholder': 'Tidak dipilih',

  'V4.welfare.pause.record.submitTime': 'Waktu penyerahan:',
  'V4.welfare.pause.record.type': 'Jenis operasi:',
  'V4.welfare.pause.record.usedTime': 'Waktu jeda yang digunakan:',
  'V4.welfare.pause.record.remainTime': 'Waktu jeda yang tersisa:',
  'V4.welfare.pause.record.pause': 'Jeda penagihan',
  'V4.welfare.pause.record.resume': 'Lanjutkan secara manual',
  'V4.welfare.pause.record.month': 'Bulan',

  // 留学生认证页
  'V4.welfare.intlAuth.notLogin': 'Belum login',
  'V4.welfare.intlAuth.completed': 'Anda telah menyelesaikan sertifikasi mahasiswa internasional',
  'V4.welfare.intlAuth.goForIt': 'Selesaikan sertifikasi mahasiswa internasional segera',
  'V4.welfare.intlAuth.pause': 'Jeda keanggotaan',
  'V4.welfare.intlAuth.pause.desc': 'Tunda penagihan waktu VIP',
  'V4.welfare.intlAuth.vip.title': 'Berikan 7 hari waktu VIP',
  'V4.welfare.intlAuth.vip.desc': 'Setelah otentikasi pertama berhasil',
  'V4.welfare.intlAuth.discount.title': 'Diskon 10% Per Tahun',
  'V4.welfare.intlAuth.discount.desc': 'Dapatkan kupon diskon 10% setiap bulan',
  'V4.welfare.intlAuth.invite.title': '+5% Bonus Teman',
  'V4.welfare.intlAuth.invite.desc': 'Hadiah waktu tambahan',
  'V4.welfare.intlAuth.coupon.title': 'Gonest Kupon Pengiriman ¥50',
  'V4.welfare.intlAuth.coupon.desc': '3 kupon eksklusif',
  'V4.welfare.intlAuth.contact.title': 'Tambahkan WeChat untuk menerima manfaat',
  'V4.welfare.intlAuth.contact.desc': 'Banyak hadiah menarik',
  'V4.welfare.intlAuth.contact.btn': 'dapatkan',
  'V4.welfare.intlAuth.received': 'dapatkan',
  'V4.welfare.intlAuth.receive': 'dapatkan',
  'V4.welfare.intlAuth.welfare.title': 'Manfaat Eksklusif',
  'V4.welfare.intlAuth.pause.btn': 'dapatkan',
  'V4.welfare.intlAuth.receive.btn': 'dapatkan',
  'V4.welfare.intlAuth.invite.btn': 'dapatkan',
  'V4.welfare.intlAuth.email.error': 'Format email salah!',
  'V4.welfare.intlAuth.desc.tip': 'Informasi berikut ini hanya digunakan untuk memverifikasi identitas mahasiswa internasional dan tidak digunakan sebagai login atau kata sandi. Hanya mahasiswa internasional (termasuk mahasiswa di Hong Kong, Makau, dan Taiwan) yang dapat mendaftar, dan alamat email pendidikan mahasiswa tersebut asli dan dapat diverifikasi.',
  'V4.welfare.intlAuth.auth.btn': 'Otentikasi',
  'V4.welfare.intlAuth.email.placeholder': 'Email pendidikan sekolah',
  'V4.welfare.intlAuth.verifyCode.placeholder': 'Kode verifikasi email',
  'V4.welfare.intlAuth.email.error.tip': 'Jika alamat email tidak dapat diautentikasi, Anda dapat memeriksa apakah alamat tersebut telah dicegat oleh email iklan. Untuk pertanyaan lebih lanjut, klik ',
  'V4.welfare.intlAuth.email.error.tip.link': 'Hubungi layanan pelanggan',

  'V4.welfare.intlAuth.getCode': 'Kode Verifikasi',
  'V4.welfare.intlAuth.getCode.error': 'Gagal mendapatkan kode verifikasi',
  'V4.welfare.intlAuth.getCode.success': 'Kode verifikasi telah dikirim, silakan periksa',
  'V4.welfare.intlAuth.certification.success': 'Otentikasi berhasil',
  'V4.welfare.intlAuth.certification.error': 'Otentikasi gagal',
  'V4.welfare.intlAuth.getCertificateInfo.error': 'Gagal memperoleh data',
  'V4.welfare.intlAuth.getWelfare.success': 'Durasi VIP 7 hari telah berhasil diterima',
  'V4.welfare.intlAuth.getWelfare.error': 'Gagal mengumpulkan',
  'V4.welfare.intlAuth.getCode.reGet': 'Kirim ulang',
  'V4.welfare.foreignRule.getCertificateInfo.error': 'Gagal memperoleh data',
}
const cancel = {
  'cancel.title.reminder': 'Penghapusan akun',
  'cancel.title.auth': 'Verifikasi Identitas',
  "cancel.reminder.artical": `
    <div style="color: #90A1DC; ">
      Penghapusan akun tidak bisa dibatalkan. Baca peringatan penting berikut:
    </div>
    <p>
      1. Sebelum menghapus, pastikan sudah membatalkan layanan berlangganan bulanan semua platform. Lihat <a href="{url}">panduan pembatalan</a> untuk melakukannya. Tanpa pembatalan, penghapusan akun tidak bisa dilakukan.
    </p>
    <p>
      2. Ada 15 hari tunggu dari permohonan sampai penghapusan sukses. Bisa membatalkan selama itu. Akun akan dihapus setelah 15 hari.
    </p>
    <p>
      3. Akun yang dihapus akan menghapus semua data. Akun tidak bisa login dan tidak bisa dikembalikan. Hak-haknya, seperti sisa keanggotaan, saldo koin, juga hilang dan tidak bisa dikembalikan.
    </p>
    <p>
      4. Setelah dihapus, nomor HP, email, dan login pihak ketiga akan dilepaskan. Bisa digunakan untuk akun lain.
    </p>
    <p>
      5. Akun yang dihapus dan didaftar ulang tidak bisa dapatkan manfaat pengguna baru yang sudah pernah didapat sebelumnya, seperti pemberian VIP super, hadiah koin undangan.
    </p>
  `,
  'cancel.reminder.agree': 'Telah membaca dan menyetujui: QuickFox',
  'cancel.reminder.agreement': 'Perjanjian Pembatalan Akun',
  'cancel.reminder.next': 'Lanjut',
  'cancel.reminder.read': 'Harap baca pengingat di atas dengan cermat',
  'cancel.reminder.cancelSign': 'Layanan berlangganan bulanan {signTypeText} belum dibatalkan. Harap konfirmasi pembatalan sebelum melanjutkan penghapusan akun.',
  'cancel.auth.input': 'Masukkan kata sandi akun saat ini untuk menyelesaikan verifikasi',
  'cancel.auth.confirm': 'Konfirmasi Pembatalan',
  'cancel.auth.tips': 'Setelah mengajukan pembatalan, Anda akan memiliki masa tunggu pembatalan selama 15 hari. Anda dapat masuk kembali kapan saja selama masa tunggu ini untuk menghentikan pembatalan.',
  'cancel.auth.pwd': 'Silakan masukkan kata sandi Anda',
  'cancel.auth.relogin.third': 'Harap masuk kembali dengan akun pihak ketiga mana pun untuk menyelesaikan verifikasi',
  'cancel.auth.relogin': 'Masuk kembali',
  'cancel.auth.please': 'Silakan',
  'cancel.auth.finish': 'Verifikasi selesai',
  'cancel.auth.unDetected': 'Akun pihak ketiga tidak terdeteksi, silakan coba hubungi layanan pelanggan',
  'cancel.auth.inconsistent': 'Akun pihak ketiga yang Anda masuk tidak sesuai dengan akun yang saat ini terikat, silakan coba lagi',
  'cancel.auth.failed': 'Verifikasi akun pihak ketiga gagal',
  'cancel.auth.failed.accident': 'Verifikasi gagal',
  'cancel.wx.pay': 'Kelola pembaruan otomatis',
  'cancel.tips.userInfoFailed': 'Gagal mengambil informasi pengguna, silakan coba lagi nanti',
  'cancel.tips.unexpectedError': 'Terjadi kesalahan yang tidak terduga',
  'cancel.tips.failToCheckSignStatus': 'Gagal memeriksa status kontrak',
};
const memberi = {
  'memberi.title': 'Tukar keanggotaan',
  'memberi.valicode': 'Masukkan kode penukaran',
  'memberi.loginTip': 'Anda bisa menukar setelah login',
  'memberi.loginBtn': 'Masuk/Daftar',
  'memberi.placeholder': 'Masukkan kode penukaran',
  'memberi.getcode': 'Tukar Sekarang',
  'memberi.descTitle': 'Aturan Penukaran',
  'memberi.desc1': 'Kode penukaran adalah produk manfaat eksklusif QuickFox. Jangan menjual atau melakukan aktivitas komersial dengan kode penukaran. QuickFox berhak mencabut durasi keanggotaan jika dilanggar.',
  'memberi.desc2': 'Setelah penukaran berhasil, Anda akan mendapatkan durasi VIP yang sesuai.',
  'memberi.desc3': 'Pengguna yang sudah memiliki durasi keanggotaan VIP dan yang masih dalam status kontrak akan memperpanjang durasi VIP setelah penukaran berhasil.',

  'memberi.desc4': 'QuickFox memiliki hak untuk menafsirkan aturan ini dalam batas yang ditentukan oleh hukum. Jika Anda memiliki pertanyaan, silakan hubungi layanan pelanggan online.',
  'memberi.success': 'Penukaran berhasil',
  'memberi.fail': 'Penukaran gagal',
  'memberi.success1': 'Sudah diperoleh',
  'memberi.ok': 'Baik',
  'memberi.blacklistTips': 'Akun Anda berisiko dan tidak dapat menggunakan kode penukaran.',
};
const customizedMembership = {
  'customizedMembership.viptimer': 'Sisa Waktu',
  'customizedMembership.concat': 'Segera Hubungi Layanan Pelanggan untuk Mendapatkan Rute Khusus Eksklusif',
  'customizedMembership.desc1': 'Jaminan Bandwidth Eksklusif',
  'customizedMembership.desc2': 'Pemutaran Video 4K Instan',
  'customizedMembership.desc3': 'Streaming Lancar',
  'customizedMembership.desc4': 'Garis Ganda untuk Stabilitas Ganda',
  'customizedMembership.desc5': 'Tiga Perangkat Online Secara Bersamaan',
  'customizedMembership.desc6': 'Dukungan Penuh Klien',
  'customizedMembership.btn': 'Konsultasi Perpanjangan',
  'customizedMembership.btn1': 'Konsultasi Pembelian',
  'customizedMembership.title': 'Keanggotaan Kustom',
};
const sportsQuiz = {
  'sportsQuiz.title': 'Detail Acara',
  'sportsQuiz.shareAndGetCoins': 'Berbagi Cepat untuk Dapat Koin',
  'sportsQuiz.how2play': 'Pengenalan Permainan',
  'sportsQuiz.rule': 'Aturan Acara Piala Dunia',
  'sportsQuiz.guessed': 'Anda Sudah Menebak',
  'sportsQuiz.advance': 'Naik Tingkat',
  'sportsQuiz.win': 'Menang',
  'sportsQuiz.draw': 'Seri',
  'sportsQuiz.guessWithCoins': 'Gunakan {coins} koin untuk menebak',
  'sportsQuiz.ifGuessRight': 'Tebak dengan benar untuk menang',
  'sportsQuiz.includes': 'Hasil pertandingan termasuk perpanjangan waktu dan adu penalti',
  'sportsQuiz.leftTime': 'Sisa waktu menebak',
  'sportsQuiz.leftQuota': 'Sisa slot partisipasi',

  'sportsQuiz.end': 'Prediksi pertandingan ini telah berakhir',
  'sportsQuiz.others': 'Silakan ikuti pertandingan lainnya~',
  'sportsQuiz.getFromNotice': '(Klaim melalui pusat pesan)',
  'sportsQuiz.youHaveGuessed': 'Anda telah berpartisipasi dalam prediksi',
  'sportsQuiz.ifThen': 'Jika {predict}{result} Anda bisa mendapatkan ',
  'sportsQuiz.guessedRight': 'Selamat atas prediksi yang benar, Anda ',
  'sportsQuiz.goGet': 'Telah dikirim, segera ke pusat pesan untuk mengambilnya~',
  'sportsQuiz.yourGuess': 'Tebakan Anda adalah:',
  'sportsQuiz.guessedWrong': 'Tebakan salah, terus semangat lain kali~',
  'sportsQuiz.goGetCoins': 'Pergi dapatkan koin',
  'sportsQuiz.platforms': 'Anda dapat menonton di platform siaran langsung berikut',
  'sportsQuiz.useQF': 'Gunakan mode video Quickfox untuk membuka kunci pembatasan hak cipta dengan satu klik',
  'sportsQuiz.cctv': 'Video CCTV',
  'sportsQuiz.yangshipin': 'Video CCTV',
  'sportsQuiz.migu': 'Video Migu',
  'sportsQuiz.tiktok': 'TikTok',
};
const device = {
  'device.title': 'Perangkat yang Masuk',
  'device.dialog.title': 'Keluar',
  'device.dialog.centent': 'Setelah keluar, perangkat ini akan memerlukan verifikasi akun saat login berikutnya. Apakah Anda yakin ingin keluar?',
  'device.dialog.ok': 'Konfirmasi',
  'device.dialog.cancel': 'Batal',
  'applyRecord.title': 'Catatan Aplikasi',
  'applyRecord.exitFailed': 'Ditolak',
  'applyRecord.using': 'Diluncurkan',
  'applyRecord.waiting': 'Menunggu',
  'device.thisDevice': 'Perangkat Ini',
  'device.exit': 'Keluar',
  'device.offline': 'Offline',
  'device.exitSuccess': 'Keluar dengan Sukses',
};
// 绑定邮箱活动
const bindEmail = {
  'bindEmail.title': 'Ikat Email',

  'bindEmail.success.tip': 'Email/Nomor telepon berhasil terikat!',
  'bindEmail.areaCode': 'Kode area',
  'bindEmail.phoneEmpty': 'Nomor telepon',
  'bindEmail.emailEmpty': 'Alamat email',
  'bindEmail.switchTo': '',
  'bindEmail.getCode': 'kode verifikasi',
  'bindEmail.findCountry': 'negara atau kode area',
  'bindEmail.emailVerify': 'Masukkan alamat email yang valid',
  'bindEmail.phoneVerify': 'Masukkan nomor telepon yang valid',
  'bindEmail.codeVerify': 'Masukkan kode verifikasi yang benar',
  'bindEmail.pwsVerify': '6-16 angka dan huruf',
  'bindEmail.pwsEmpty': 'Masukkan kata sandi',
  'bindEmail.codeEmpty': 'kode verifikasi',
  'bindEmail.phone': 'Ponsel',
  'bindEmail.email': 'Email',
};
// 任务补充
const taskSupplement = {
  'taskSupplement.redemptionDetails': 'Halaman Detail Penukaran',
  'taskSupplement.missionRules': 'Aturan Tugas',
  'taskSupplement.shareScreenshot': 'Pilih Screenshot untuk Dibagikan',
  'taskSupplement.supportChannel': 'Saat ini mendukung tangkapan layar berbagi dari platform seperti Xiaohongshu, WeChat, Weibo, Douyin, dll.',
  'taskSupplement.advisoryService': 'Harap patuhi aturan tugas. Jika ada pertanyaan, silakan hubungi layanan pelanggan.',
  'taskSupplement.auditPrompt1': 'Harap pertahankan konten yang dibagikan tetap terlihat selama masa tinjauan.',
  'taskSupplement.auditPrompt2': 'Setelah disetujui, 100 koin emas akan diberikan secara otomatis. Harap bersabar.',
  'taskSupplement.sharePoster': 'Bagikan poster',
  'taskSupplement.saveImg': 'Tekan lama gambar untuk menyimpan',
  'taskSupplement.rulesDesc4': 'Mulai sekarang, semua pengguna terdaftar dapat mengunggah tangkapan layar poster berbagi QuickFox di platform sosial (termasuk Xiaohongshu, WeChat, Weibo, Douyin, Facebook, Twitter, Instagram, Tiktok, dll.) di halaman tugas. Setelah disetujui, mereka akan menerima hadiah 100 koin emas.',
  'taskSupplement.rulesDesc5': 'Setiap pengguna dapat menyelesaikan satu tugas. Selama peninjauan, pastikan konten tetap terlihat di platform sosial agar tidak ditolak.',
  'taskSupplement.rulesDesc6': 'Tinjau dalam 2 hari',
  'taskSupplement.rulesDesc7': 'Selama kegiatan pemasaran, jika pengguna mengambil untung atau keuntungan ilegal dari manfaat, mentransfer manfaat, atau menyalahgunakannya, QuickFox dapat mencabut manfaat dan membatalkan transaksi.',
  'taskSupplement.rulesDesc8': 'Untuk info dan bantuan, hubungi dukungan online QuickFox. Tidak berafiliasi dengan Apple Inc.',
  'taskSupplement.rulesDesc9': 'QuickFox berhak menafsirkan acara ini dalam batas hukum.',

  'taskSupplement.xiecheng': 'Halaman Mendarat Ctrip',
};

// 微信续费补充
const wxPayManage = {
  'wxPayManage.activatedBusiness': 'Layanan yang Diaktifkan',
  'wxPayManage.weChatPay': 'WeChat Pay',
  'wxPayManage.continuousMonthlyMembership': 'Anggota Langganan Bulanan',
  'wxPayManage.nextRenewalTime': 'Waktu Debit Otomatis Berikutnya',
  'wxPayManage.stopService': 'Tutup Layanan',
  'wxPayManage.successfullyUnsubscribe': 'Berhasil Membatalkan Langganan Bulanan WeChat',
};

// 支付宝实名认证
const zfbManage = {
  'zfbManage.cancelledVerification': 'Verifikasi Pengguna Dibatalkan',
  'zfbManage.enterNumber': 'Masukkan nomor KTP 18 digit yang valid',
  'zfbManage.enterX': 'Jika KTP diakhiri dengan huruf, silakan masukkan',
  'zfbManage.enterID': 'Masukkan nomor KTP yang terdaftar di KTP',
  'zfbManage.enterName': 'Masukkan nama asli yang terdaftar di KTP',
  'zfbManage.verificationFailed': 'Verifikasi informasi KTP gagal',
  'zfbManage.getCode': 'Silakan kembali ke klien untuk mendapatkan kode QR lagi',
  'zfbManage.realNameverify': 'Verifikasi identitas',
  'zfbManage.successed': 'Selamat, Anda telah menyelesaikan verifikasi identitas',
  'zfbManage.complete': 'Selesai',
  'zfbManage.callChatTextPrefix': 'Pengguna yang bukan penduduk Republik Rakyat Tiongkok dapat',
  'zfbManage.callChatText': 'Hubungi Layanan Pelanggan',
  'zfbManage.callChatTextSuffix': 'Selesaikan Verifikasi',
  'zfbManage.authentication': 'Syarat Penggunaan Verifikasi Identitas',
  'zfbManage.realNameVerifyDesc1': 'Untuk memastikan keamanan akun Anda, harap selesaikan verifikasi identitas.',
  'zfbManage.realNameVerifyDesc2': 'Layanan verifikasi identitas saat ini disediakan oleh "Alipay". Harap instal dan autentikasi aplikasi terkait terlebih dahulu.',
  'zfbManage.realNameVerifyDesc3': 'Informasi identitas yang Anda kirimkan hanya digunakan untuk verifikasi identitas. QuickFox berjanji tidak akan menggunakannya untuk skenario lain atau mengungkapkannya kepada pihak ketiga.',
  'zfbManage.qRealNameverify': 'Verifikasi Identitas QuickFox',
  'zfbManage.enterRealName': 'Silakan masukkan nama asli sesuai KTP',
  'zfbManage.realName': 'Nama Asli',
  'zfbManage.enterRealID': 'Silakan masukkan nomor KTP 18 digit Anda',
  'zfbManage.IDCode': 'Nomor KTP',
  'zfbManage.now': 'Verifikasi Sekarang',
  'zfbManage.go': 'Menuju verifikasi',
  'zfbManage.upgrade': 'Antarmuka ini tidak didukung oleh klien saat ini, harap tingkatkan',
  'zfbManage.failed': 'Gagal memuat',
  'zfbManage.sendData': 'Dekripsi data yang dikirim',
};
const blacklistBlocking = {
  'blacklist.youRisk': 'Akun Anda berisiko',
  'blacklist.cannot': 'Sementara tidak dapat berpartisipasi dalam tugas pusat kesejahteraan',
  'blacklist.sendEmail': 'Jika ada keberatan, silakan email info@quickfox.com.cn untuk mengajukan banding',
  'vip.cantuse': 'Akun sub perusahaan tidak dapat melakukan operasi ini',
};
const FraudBlacklistBlocking = {
  'blacklist.policy': 'Karena alasan kebijakan',
  'blacklist.policyDetail': 'Negara atau wilayah Anda tidak lagi menyediakan layanan',
  'blacklist.thanks': 'Terima kasih atas pengertian dan dukungan Anda',
};
const weeklyReward = {
  'weeklyReward.title': 'Hadiah Mingguan',
  'weeklyReward.award': '{vipTime}{timeType} Waktu Percepatan VIP',
  'weeklyReward.award.desc': 'Layanan Eksklusif, Dapatkan Lebih Banyak Waktu Anggota',
  'weeklyReward.addNow': 'Tambahkan Sekarang',
  'weeklyReward.cancel': 'Batal',
  'weeklyReward.confirm': 'Yakin',
  'weeklyReward.rule': 'Peraturan',
  'weeklyReward.rule.desc': 'Layanan 1-1 Eksklusif, Dapatkan Lebih Banyak Waktu Anggota',
  'weeklyReward.remainingCount': 'Jumlah Undian periode ini sudah habis',
  'weeklyReward.immediately': '',
  'weeklyReward.lottery': 'Rotasi',
  'weeklyReward.lotteryCount': '{count} peluang',
  'weeklyReward.thanks': 'Tidak Menang',
  'weeklyReward.record': 'Log',
  'weeklyReward.lotteryFailed': 'Undian Gagal',
  'weeklyReward.activityExpired': 'Acara Kadaluarsa',
  'weeklyReward.activityEnded': 'Acara Berakhir',
  'weeklyReward.soonStart': 'Blm mulai',
  'weeklyReward.startLater': '{time} Mulai',
  'weeklyReward.stock': 'Stok {count}%',
  'weeklyReward.notStart': 'Sesi ini belum dimulai',
  'weeklyReward.ended': 'Sesi ini telah berakhir',
  'weeklyReward.noActivity': 'Tidak Ada Informasi Acara',
  'weeklyReward.record.title': 'Hadiah Mingguan',
  'weeklyReward.record.time': '{timeStr} Waktu VIP',
  'weeklyReward.rule.title': 'Peraturan',
};
const zh_CN = {
  ...about,
  ...contact,
  ...help,
  ...helpDetail,
  ...http,
  ...notice,
  ...tsupport,
  ...Welfare,
  ...PageTitle,
  ...Common,
  ...Tips,
  ...ActivationRecord,
  ...TimeType,
  ...tutorial,
  ...pointEventEnd,
  ...taskCenterV3,
  ...pointEventV4,
  ...cancel,
  ...memberi,
  ...sportsQuiz,
  ...device,
  ...customizedMembership,
  ...bindEmail,
  ...taskSupplement,
  ...wxPayManage,
  ...zfbManage,
  ...blacklistBlocking,
  ...FraudBlacklistBlocking,
  ...weeklyReward,
};

export default zh_CN;